"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_query_1 = require("@tanstack/react-query");
const Alert_1 = __importDefault(require("../../../components/Alert"));
const SpinnerOverlay_1 = __importDefault(require("../../../components/SpinnerOverlay/SpinnerOverlay"));
const formik_1 = require("formik");
const store_1 = require("../../../store/store");
const OrganizationSelect_1 = __importDefault(require("../../../components/OrganizationSelect/OrganizationSelect"));
const SelectOrganization = () => {
    var _a;
    const user = (0, store_1.useAppSelector)((state) => state.app.user);
    const queryClient = (0, react_query_1.useQueryClient)();
    const [confirmed, setConfirmed] = (0, react_1.useState)(false);
    const [confirmSuccess, setConfirmSuccess] = (0, react_1.useState)(false);
    const [errorMessage, setErrorMessage] = (0, react_1.useState)('');
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const organizationField = {
        name: 'organizationId',
        key: 'organizationId',
        group: 'organizationId',
        value: (_a = user === null || user === void 0 ? void 0 : user.organizationId) !== null && _a !== void 0 ? _a : null,
    };
    return ((0, jsx_runtime_1.jsx)(formik_1.Formik, { enableReinitialize: true, initialValues: { organizationId: organizationField.value }, onSubmit: (values) => __awaiter(void 0, void 0, void 0, function* () {
            setConfirmed(false);
            setErrorMessage('');
            setConfirmSuccess(false);
            setIsLoading(true);
            try {
                yield axios.put('/api/put-donor-organization-information', {
                    organizationId: values.organizationId,
                });
                setConfirmSuccess(true);
                yield queryClient.invalidateQueries({ queryKey: ['GetDonorContactInformation'] });
                yield queryClient.invalidateQueries({ queryKey: ['get-user'] });
            }
            catch (err) {
                const message = err instanceof Error ? err.message : 'Error';
                setErrorMessage(message);
                setConfirmSuccess(false);
            }
            finally {
                setConfirmed(true);
                setIsLoading(false);
            }
        }), children: ({ values, setFieldValue }) => ((0, jsx_runtime_1.jsxs)(SpinnerOverlay_1.default, { visible: isLoading, children: [(0, jsx_runtime_1.jsxs)(formik_1.Form, { className: "select-organization-form", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: `${organizationField.key}-select`, className: "visually-hidden", children: __.trans('save-life-at-work.employer') }), (0, jsx_runtime_1.jsx)(OrganizationSelect_1.default, { className: "organization-select", value: values.organizationId, onChange: (id) => setFieldValue('organizationId', id !== null && id !== void 0 ? id : null), inputId: `${organizationField.key}-select`, placeholder: __.trans('contact-info.employerPlaceholder'), ariaLabel: __.trans('contact-info.employerAriaLabel') }), (0, jsx_runtime_1.jsx)("button", { type: "submit", className: "btn theme-button-primary save-organization-button", children: __.trans('save-life-at-work.save-button') })] }), (0, jsx_runtime_1.jsxs)(Alert_1.default, { color: confirmSuccess ? 'success' : 'danger', isOpen: confirmed, children: [confirmed &&
                            (confirmSuccess
                                ? __.trans('save-life-at-work.successful-save-message')
                                : __.trans('save-life-at-work.unsuccessful-save-messagel')), errorMessage && ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("br", {}), errorMessage] }))] })] })) }));
};
exports.default = SelectOrganization;
